import React from 'react';
import { ShieldCheck, Lock, CreditCard, Zap } from 'lucide-react';
import { Countdown } from './ui/Countdown';
import { AnimatedSection } from './ui/AnimatedSection';
export function FinalCTA() {
  return <AnimatedSection className="bg-navy-900 border-t border-dark-border pt-16 sm:pt-20 pb-20 sm:pb-24" data-id="element-41">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-42">
        <h2 className="text-xl sm:text-2xl md:text-3xl font-heading font-bold text-white mb-6 sm:mb-8 uppercase tracking-wide leading-tight" data-id="element-43">
          ⏰ EL PRECIO CIERRA EN:
        </h2>

        <div className="mb-12 sm:mb-16" data-id="element-44">
          <Countdown data-id="element-45" />
        </div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-6 max-w-3xl mx-auto mb-10 sm:mb-12" data-id="element-46">
          {/* Option 1 */}
          <div className="bg-dark-card border border-dark-border rounded-xl p-5 sm:p-6 flex flex-col items-center text-center" data-id="element-47">
            <h3 className="text-lg sm:text-xl font-heading font-bold text-white mb-2 leading-tight" data-id="element-48">
              📘 MEGA PACK KINESIOLOGÍA
            </h3>
            <p className="text-xs sm:text-sm text-gray-400 mb-4" data-id="element-49">
              6 Tomos + 6 Bonos · Estudiantes avanzados y kinesiólogos junior
            </p>
            <div className="mb-5 sm:mb-6" data-id="element-50">
              <span className="text-gray-500 line-through text-sm mr-2" data-id="element-51">
                $51.000
              </span>
              <span className="text-2xl sm:text-3xl font-heading font-bold text-white" data-id="element-52">
                $19.990 <span className="text-sm text-gray-400" data-id="element-53">ARS</span>
              </span>
            </div>
            <a href="#" className="w-full bg-navy-800 hover:bg-navy-700 text-white border border-dark-border font-bold text-sm sm:text-base py-3 rounded-full transition-colors" data-id="element-54">
              → QUIERO EL MEGA PACK
            </a>
          </div>

          {/* Option 2 */}
          <div className="bg-navy-950 border-2 border-gold rounded-xl p-5 sm:p-6 flex flex-col items-center text-center relative shadow-[0_0_30px_rgba(201,168,76,0.15)]" data-id="element-55">
            <h3 className="text-lg sm:text-xl font-heading font-bold text-white mb-2 leading-tight" data-id="element-56">
              🏆 MEGA PACK + RAZONAMIENTO AVANZADO ⭐
            </h3>
            <p className="text-xs sm:text-sm text-gold mb-4" data-id="element-57">
              6 Tomos + 6 Bonos + 30 casos clínicos adicionales
            </p>
            <div className="mb-5 sm:mb-6" data-id="element-58">
              <span className="text-gray-500 line-through text-sm mr-2" data-id="element-59">
                $69.000
              </span>
              <span className="text-2xl sm:text-3xl font-heading font-bold text-gold" data-id="element-60">
                $27.990 <span className="text-sm text-gray-400" data-id="element-61">ARS</span>
              </span>
            </div>
            <a href="#" className="w-full bg-gold hover:bg-gold-hover text-navy-950 font-bold text-sm sm:text-base py-3 rounded-full transition-all transform hover:scale-105" data-id="element-62">
              → QUIERO EL PACK + AVANZADO
            </a>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-3 sm:gap-4 md:gap-6 text-xs sm:text-sm text-gray-400" data-id="element-63">
          <div className="flex items-center gap-1.5 sm:gap-2" data-id="element-64">
            <Lock size={16} className="text-green-400 flex-shrink-0" data-id="element-65" /> Pago
            100% seguro
          </div>
          <div className="flex items-center gap-1.5 sm:gap-2" data-id="element-66">
            <Zap size={16} className="text-yellow-400 flex-shrink-0" data-id="element-67" /> Acceso
            en 5 minutos
          </div>
          <div className="flex items-center gap-1.5 sm:gap-2" data-id="element-68">
            <ShieldCheck size={16} className="text-blue-400 flex-shrink-0" data-id="element-69" />{' '}
            Garantía 7 días
          </div>
          <div className="flex items-center gap-1.5 sm:gap-2" data-id="element-70">
            <CreditCard size={16} className="text-gray-300 flex-shrink-0" data-id="element-71" />{' '}
            Mercado Pago | Tarjeta | Transferencia
          </div>
        </div>
      </div>
    </AnimatedSection>;
}